import React from "react";

export default function CirculosRojos(props) {
  return (
    <div className="row circulosRojos" style={{ marginBottom: "3%" }}>
      <div className="col s0 m2 l2 offset-m1 offset-l1 center-align">
        <div className="circle-feature valign-wrapper">
          <div>
            <div
              className="center-align white-text"
              style={{ fontFamily: "Audi Extended" }}
            >
              {" "}
              Version{" "}
            </div>
            <div
              className="center-align white-text"
              style={{ fontFamily: "Audi Normal", fontSize: "0.8em" }}
            >
              {props.vehiculo.version}
            </div>
          </div>
        </div>
      </div>

      <div className="col s0 m2 l2  center-align">
        <div className="circle-feature valign-wrapper">
          <div>
            <div
              className="center-align white-text"
              style={{ fontFamily: "Audi Extended" }}
            >
              {" "}
              Tipo{" "}
            </div>
            <div
              className="center-align white-text"
              style={{ fontFamily: "Audi Normal", fontSize: "0.8em" }}
            >
              {props.vehiculo.tipo}
            </div>
          </div>
        </div>
      </div>

      <div className="col s0 m2 l2 center-align">
        <div className="circle-feature valign-wrapper">
          <div>
            <img
              className="responsive-img"
              style={{ width: "70%" }}
              src="images/icons/img-color.png"
              alt="color"
            />

            <div
              className="center-align white-text"
              style={{ fontFamily: "Audi Normal", fontSize: "0.8em" }}
            >
              {props.vehiculo.color}
            </div>
          </div>
        </div>
      </div>

      <div className="col s0 m2 l2 center-align">
        <div className="circle-feature valign-wrapper">
          <div>
            <div
              className="center-align white-text"
              style={{ fontFamily: "Audi Extended" }}
            >
              {" "}
              Modelo{" "}
            </div>
            <div
              className="center-align white-text"
              style={{ fontFamily: "Audi Normal", fontSize: "2em" }}
            >
              {props.vehiculo.anio}
            </div>
          </div>
        </div>
      </div>

      <div className="col s0 m2 l2 center-align">
        <div className="circle-feature valign-wrapper">
          <div>
            <img
              className="responsive-img"
              style={{ width: "70%" }}
              src="images/icons/img-gear.png"
              alt="transmision"
            />
            <div
              className="center-align white-text"
              style={{ fontFamily: "Audi Extended", fontSize: "0.8em" }}
            >
              {" "}
              Transmision{" "}
            </div>
            <div
              className="center-align white-text"
              style={{ fontFamily: "Audi Normal", fontSize: "0.8em" }}
            >
              {props.vehiculo.transmision}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
